// extracted by mini-css-extract-plugin
module.exports = {"container":"MedicationList_container__1ERV-","header":"MedicationList_header__3ahBS","medicationListWrapper":"MedicationList_medicationListWrapper__2_LSl"};